import Zoom from '../../chart/zoom';

export default instance => {
  instance.attachEvent('history:onZoomChange', zoomLevel => {
    Zoom.setZoomLevel(zoomLevel);
  });
};
